var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overflow-auto d-flex justify-center md:justify-end"},[_c('b-pagination-nav',{attrs:{"link-gen":_vm.linkGen,"number-of-pages":Math.ceil(_vm.totalItems/_vm.itemsPerPage),"use-router":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }